import { Injectable, inject } from '@angular/core';

import { StatePersistServiceRegistry } from './state-storage-persist-service.registry';

@Injectable({ providedIn: 'root' })
export class StateConverterService {
    private statePersistServices = inject(StatePersistServiceRegistry);

    convert(state: any) {
        return Object.entries(state)
            .map(([key, value]) => ({ feature: key, state: value }))
            .reduce(
                (aggregate, current) => {
                    const service = this.statePersistServices.get(current.feature);
                    if (service) {
                        aggregate[current.feature] = service.save(current.state);
                    }

                    return aggregate;
                },
                {} as Record<string, any>,
            );
    }
}
